import PhysicianAndPracticeInfoForm from './PhysicianAndPracticeInfoForm';

export default PhysicianAndPracticeInfoForm;



// WEBPACK FOOTER //
// ./src/views/components/PhysicianAndPracticeInfoForm/index.js